import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import {
  extractApiMessage,
  uploadCroppedImport,
} from "./externalImportCropUtils";

/**
 * Manages the external-import crop session outside the Media Library modal
 * so only one modal is visible at a time.
 */
const useExternalImportCrop = (onSelect) => {
  const [cropSession, setCropSession] = useState(null);
  const [applyingCrop, setApplyingCrop] = useState(false);

  const handleImportForCrop = useCallback((session) => {
    setCropSession(session);
  }, []);

  const handleCropCancel = useCallback(() => {
    setCropSession(null);
  }, []);

  const handleCropComplete = useCallback(
    async (file, _preview, meta) => {
      if (!cropSession) return;
      setApplyingCrop(true);
      try {
        const uploaded = await uploadCroppedImport(
          file,
          cropSession.cropFileName,
          cropSession.pendingImport,
          meta
        );
        if (!uploaded?.mediaUrl) {
          toast.error("Unable to apply crop. Please try again.");
          return;
        }
        onSelect?.(uploaded);
        setCropSession(null);
      } catch (err) {
        toast.error(
          extractApiMessage(err) || "Unable to apply crop. Please try again."
        );
      } finally {
        setApplyingCrop(false);
      }
    },
    [cropSession, onSelect]
  );

  return {
    cropSession,
    applyingCrop,
    handleImportForCrop,
    handleCropCancel,
    handleCropComplete,
    isCropOpen: Boolean(cropSession),
  };
};

export default useExternalImportCrop;
